import ProductionMonitorContainer from '@components/containers/productionMonitor';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

/**
 * Deliberately a top-level path rather than /cm-sites/production-monitor: that would be
 * swallowed by the /cm-sites/:warehouseId route and open a site page named "production-monitor".
 */
const ProductionMonitor: FC = () => (
    <AppLayout>
        <ProductionMonitorContainer />
    </AppLayout>
);

export default ProductionMonitor;
